import { Currency, CurrencyNames } from "@redotech/money/iso4217/currencies";
import { memo, useMemo, useState } from "react";
import { TextRedoListItem } from "../list/redo-list";
import {
  RedoDropdownInputSize,
  RedoSingleSelectDropdownInput,
} from "./redo-single-select-dropdown-input";

const CURRENCY_OPTIONS: TextRedoListItem<Currency>[] = Object.values(Currency)
  .map((currency) => ({
    type: "text" as const,
    id: currency,
    text: CurrencyNames[currency],
    value: currency,
  }))
  .sort((a, b) => a.text.localeCompare(b.text));

interface RedoCurrencySelectorProps {
  value: string;
  setValue: (value: string) => void;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  size?: RedoDropdownInputSize;
  className?: string;
}

export const RedoCurrencySelector = memo(function RedoCurrencySelector({
  value,
  setValue,
  label = "Currency",
  placeholder = "Select currency",
  disabled = false,
  size = "xs",
  className,
}: RedoCurrencySelectorProps) {
  const [currencySearchString, setCurrencySearchString] = useState("");

  const filteredCurrencies = useMemo(
    () =>
      !currencySearchString
        ? CURRENCY_OPTIONS
        : CURRENCY_OPTIONS.filter(
            (option) =>
              option.value
                .toLowerCase()
                .includes(currencySearchString.toLowerCase()) ||
              option.text
                .toLowerCase()
                .includes(currencySearchString.toLowerCase()),
          ),
    [currencySearchString],
  );

  return (
    <RedoSingleSelectDropdownInput<Currency>
      className={className}
      data-arbiter="RedoCurrencySelector"
      disabled={disabled}
      label={label}
      options={filteredCurrencies}
      optionSelected={({ item }) => {
        setValue(item?.value || Currency.USD);
      }}
      placeholder={placeholder}
      searchPlaceholder="Search currencies..."
      searchString={currencySearchString}
      selectedItem={CURRENCY_OPTIONS.find(
        (currency) => currency.value === value,
      )}
      setSearchString={setCurrencySearchString}
      size={size}
    />
  );
});
